/**
 * Tableau des critères de la carte Abonnement replié ou déplié (DEV-2480,
 * demande de Mathieu du 23/10).
 *
 * INTENTION. Au repos, la carte ne montre que la jauge (barre de synthèse) ;
 * le tableau des critères se déplie par « Voir le détail ». Le choix tient le
 * temps de la session au plus (sessionStorage), jamais au-delà, et vaut par
 * abonnement : replier une carte n'efface pas le choix d'une autre.
 *
 * Mémoire : un objet JSON sous une seule clé, `{ "*": bool, "<abonnement>":
 * bool }`. Une carte lit `obj[abonnement] ?? obj["*"] ?? false` : le défaut
 * global `*` (posé par le lien « Comprendre les critères : voir le tableau »
 * de la page des sources) ouvre toutes les cartes, un choix explicite par
 * carte prime ensuite. Stockage indisponible ou illisible : replié, l'écran
 * fonctionne sans.
 */

/** Clé de la mémoire dans le sessionStorage */
export const CLE_DETAIL_DECOMPTE = "abonnement.decompte.detail"

/** Entrée du défaut global, valable pour toutes les cartes */
export const DETAIL_TOUTES_LES_CARTES = "*"

type MemoireDetail = Record<string, boolean>

/** Mémoire lue, `{}` si absente, illisible ou indisponible */
function lireMemoire(): MemoireDetail {
    try {
        const brut = globalThis.sessionStorage?.getItem(CLE_DETAIL_DECOMPTE)
        if (!brut) return {}
        const obj: unknown = JSON.parse(brut)
        if (!obj || typeof obj !== "object" || Array.isArray(obj)) return {}
        const memoire: MemoireDetail = {}
        for (const [k, v] of Object.entries(obj)) {
            if (typeof v === "boolean") memoire[k] = v
        }
        return memoire
    } catch {
        return {}
    }
}

/**
 * Vrai si le tableau de cette carte doit s'ouvrir déplié
 * @param abonnement - identifiant de la carte (abonnement)
 */
export function lireDetailOuvert(abonnement: string): boolean {
    const m = lireMemoire()
    return m[abonnement] ?? m[DETAIL_TOUTES_LES_CARTES] ?? false
}

/**
 * Retient le choix pour la session
 * @param abonnement - identifiant de la carte, ou `*` pour toutes les cartes
 * @param ouvert - vrai si le tableau est déplié
 */
export function memoriserDetailOuvert(
    abonnement: string,
    ouvert: boolean
): void {
    try {
        const m = lireMemoire()
        m[abonnement] = ouvert
        globalThis.sessionStorage?.setItem(
            CLE_DETAIL_DECOMPTE,
            JSON.stringify(m)
        )
    } catch {
        // stockage indisponible : le choix vaut pour l'écran affiché seulement
    }
}
